import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LandingFooterComponent } from '@common-standalone//landing/landing-footer/landing-footer.component';
import { CleverTapEventsService } from '@commoncore/services/clevertap-events-service';
import { LandingService } from '@commoncore/services/landing.service';
import { LoggerService } from '@commoncore/services/logger.service';
import { UniversalService } from '@commoncore/services/universal.service';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';
import { TranslateModule } from '@ngx-translate/core';
import { LandingHeaderComponent } from '@common-standalone//landing/landing-header/landing-header.component';
import { LandingSliderComponent } from '@common-standalone//landing/landing-slider/landing-slider.component';
@Component({
  standalone:true,
  selector: 'lib-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  imports:[LandingHeaderComponent,LandingFooterComponent,DependenciesModule,TranslateModule,LandingSliderComponent]
})
export class LandingComponent implements OnInit, OnDestroy,AfterViewInit {
  show: boolean = true;
  isMobile: boolean;
  currentIndex = 0;
  intervalId: any;
  public downloadAppLink = ENV_CONSTANTS["constants"]["landingDownloadappLink"];
  private clicked = false;
  isDragging: boolean = false;
  slideValue:any= 50;


  constructor(public universalService:UniversalService,public loggerService:LoggerService,public landingService:LandingService,public cleverTapEventsService:CleverTapEventsService,public router:Router,private renderer: Renderer2) { }
  @HostListener('window:orientationchange', [])orientationchange(){
    this.onOrientationChange();
  }
  @HostListener("window:scroll", []) onWindowScroll() {
      // do some stuff here when the window is scrolled
    var scrollTop = document.documentElement.scrollTop
    if(scrollTop == 0){
      document.getElementById("go-to-top").style.opacity = '0';
    }else{
      document.getElementById("go-to-top").style.opacity = '1';
    }
    this.animateText();
    // this.animateDevice();
    // this.slideUpFeaturedevice();
  }

  @HostListener('window:resize', [])resize(){
    var self = this;
    this.universalService.checkDeviceType();
  }

  onOrientationChange() {
    let ele = document.querySelector('.landscapeNone') as any
    // alert(window.orientation)
    if(ele && window.orientation == 90){
      ele.show()
    }else{
      ele.hide()
    }
  }

  ngOnInit(): void {
    this.universalService.isMultiLangNotSupported = false;
    this.intervalId = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % 3; 
    }, 3000);
    this.autoPlayVideo();
    this.universalService.showLoader = false;
    $('html').css({ "scroll-behavior": "smooth" });
    this.universalService.hideLeftMenu = true;
    this.universalService.currentTab = "";
    this.universalService.showThemeSwitch = true;
    this.universalService.showLangDropdown = true;
    this.universalService.showThemeSwitch = true;
    this.universalService.initThemeLanguage(this.universalService.translate);
    setTimeout(()=>{
      window.scrollTo(0, 0);
    },200)
    this.loggerService.log("inside about component")
    this.isMobile = (window.innerWidth < 991)
    let classRef = this;
    //classRef.cleverTapEventsService.landingPageViewed();
    var checkLogin =localStorage.jio;
    if(!checkLogin){
      classRef.cleverTapEventsService.nonLoginHomeScreenViewed();
    }
  }
  ngAfterContentInit(): void {
    
  }
  ngOnDestroy() {
    let htmlElem = document.getElementsByTagName('html')[0];
    htmlElem.setAttribute("data-theme", "light");
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  topReached(tt){
    this.show = false;
    var ref = this;
    setTimeout(()=>{ref.show = true;},10);
  }
  
  animateText(){
    const inViewport = (entries, observer) => {
      entries.forEach(entry => {
        entry.target.classList.toggle("text-blur-in", entry.isIntersecting);
      });
    };
    const Obs = new IntersectionObserver(inViewport);
    let elementList = document.querySelector('#jcAbout');
    const viewPort = elementList.querySelectorAll('[data-inviewport]') ;
    viewPort.forEach(EL => {
      Obs.observe(EL);
    });
  }

  openLogin(number) {
    this.cleverTapEventsService.landingPageViewedLoginBtnClicked();
    // this.lazyInjectorService.lazyInjectCss('global', this.renderer2);
    const phoneNumber = (document.getElementById('jioPhoneNumber') as HTMLInputElement)?.value;
    this.router.navigate(['/signin'], { state: { phone: phoneNumber } });
  }
  autoPlayVideo(){
    setTimeout(()=>{
      const videos = document.querySelectorAll('video');
      videos.forEach(video => {
          video.muted = true; // Ensure video is muted
          video.play().catch(() => {
              console.log(`Autoplay failed for video ID: ${video.id}. Adding user interaction.`);
              document.body.addEventListener('click', () => {
                  video.play();
              }, { once: true });
          });
      });
     },2000)
  }
  toggleFAQ(event){
    if(!event.target.getAttribute("data-toggle")) return;
    let allDivs = event.currentTarget.childNodes;
    let parentEL = event.target.parentNode.parentNode as HTMLElement;
    allDivs.forEach(element => {
      let div = element.childNodes[0] as HTMLElement;
      if(element.id == parentEL.id){
        if(div.classList.contains("border-0")){
          div.classList.remove("border-0");
        }
        else {
          div.classList.add("border-0");
        }
      }
      else{
        if(div.classList.contains("border-0")){
          div.classList.remove("border-0");
        }
      }
    });
  }
  openDownloadLink(store){
    if(store == "playstore"){
      this.cleverTapEventsService.landingPageViewedPlayStoreBtnClicked();
    }else if(store =="appstore"){
      this.cleverTapEventsService.landingPageViewedAppStoreBtnClicked();
    }
    window.open(this.downloadAppLink, "_blank", "noopener, noreferrer");
  }

  loginNoValidation(number){  
      let el = (document.getElementById(number.id)) as any;
      el.value = el.value.replace(/[^0-9]/g, '');
      if(el.value.length >= 10){
        el.value = el.value.substr(0, 10);
      }
  }
  @ViewChild('slider') slider!: ElementRef<HTMLInputElement>;
  @ViewChild('compare') compare!: ElementRef<HTMLImageElement>;
  @ViewChild('thumb') thumb!: ElementRef<HTMLSpanElement>;
  @ViewChild('divider') divider!: ElementRef<HTMLDivElement>;
  @ViewChild('container') container!: ElementRef<HTMLDivElement>;
  @ViewChild('captionBefore') captionBefore!: ElementRef<HTMLDivElement>;
  @ViewChild('captionAfter') captionAfter!: ElementRef<HTMLDivElement>;


  ngAfterViewInit() {
    this.updateComparison();
  }

  slide(event: Event) {
    this.slideValue = (event.target as HTMLInputElement).valueAsNumber;
    this.isDragging = true;
    this.updateComparison();
  }

  moveSliderOnClick(event: MouseEvent) {
    this.isDragging = false;
    const rect = this.container.nativeElement.getBoundingClientRect();
    let newValue = ((event.clientX - rect.left) / rect.width) * 100;

    this.compare.nativeElement.style.transition = "clip-path 0.3s ease-in-out";
    this.thumb.nativeElement.style.transition = "left 0.3s ease-in-out";
    this.divider.nativeElement.style.transition = "left 0.3s ease-in-out";

    this.slideValue = Math.max(0, Math.min(100, newValue));
    this.updateComparison();

    setTimeout(() => {
      this.compare.nativeElement.style.transition = "";
      this.thumb.nativeElement.style.transition = "";
      this.divider.nativeElement.style.transition = "";
    }, 300);
  }

  startDragging(event: MouseEvent | TouchEvent) {
    this.isDragging = true;
    this.moveSlider(event);
    document.addEventListener('mousemove', this.moveSlider);
    document.addEventListener('mouseup', this.stopDragging);
    document.addEventListener('touchmove', this.moveSlider);
    document.addEventListener('touchend', this.stopDragging);
  }

  moveSlider = (event: MouseEvent | TouchEvent) => {
    const clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
    const rect = this.container.nativeElement.getBoundingClientRect();
    let newValue = ((clientX - rect.left) / rect.width) * 100;

    this.slideValue = Math.max(0, Math.min(100, newValue));
    this.updateComparison();
  };

  stopDragging = () => {
    this.isDragging = false;
    document.removeEventListener('mousemove', this.moveSlider);
    document.removeEventListener('mouseup', this.stopDragging);
    document.removeEventListener('touchmove', this.moveSlider);
    document.removeEventListener('touchend', this.stopDragging);
    this.updateComparison();
  };

  private updateComparison() {
    const slidePercent = this.slideValue;
    const containerWidth = this.container.nativeElement.offsetWidth;
    const sliderX = (slidePercent / 100) * containerWidth;

    // Move the slider and images
    this.compare.nativeElement.style.clipPath = `polygon(0 0, ${slidePercent}% 0, ${slidePercent}% 100%, 0 100%)`;
    this.thumb.nativeElement.style.left = `${slidePercent}%`;
    this.divider.nativeElement.style.left = `${slidePercent}%`;

    // Update captions
    this.clipCaption(this.captionBefore.nativeElement, sliderX, true);
    this.clipCaption(this.captionAfter.nativeElement, sliderX, false);
  }

  private clipCaption(caption: HTMLElement, sliderX: number, isLeft: boolean) {
    const bounds = caption.getBoundingClientRect();
    const containerBounds = this.container.nativeElement.getBoundingClientRect();
    const captionLeft = bounds.left - containerBounds.left;
    const captionRight = captionLeft + bounds.width;

    if (isLeft) {
        caption.style.clipPath = sliderX >= captionRight ? "none" :
                                 sliderX > captionLeft ? `inset(0 ${100 - ((sliderX - captionLeft) / bounds.width) * 100}% 0 0)` :
                                 "inset(0 100% 0 0)";
    } else {
        caption.style.clipPath = sliderX <= captionLeft ? "none" :
                                 sliderX < captionRight ? `inset(0 0 0 ${100 - ((captionRight - sliderX) / bounds.width) * 100}%)` :
                                 "inset(0 0 0 100%)";
    }
  }

}
